import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GrupoService } from '../../../../services/grupos.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-editar-grupos',
  templateUrl: './editar-grupos.component.html',
  styleUrls: ['./editar-grupos.component.scss'],
})
export class EditarGruposComponent implements OnInit {
  form = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(15),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<EditarGruposComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public grupoService: GrupoService,
    private _snackBar: MatSnackBar
  ) {
    //console.log(data);
    this.form.controls.nombre.setValue(data.nombre);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    this.form.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.form.value.id_grupos = this.data.id_grupos;
    this.form.value.borrado = 0;
    //console.log(this.form.value);
    this.grupoService.actualizar(this.form.value).subscribe((data) => {
      console.log("Respuesta",data.payload);
      this.openSnackBar('Grupo editado con éxito', 'X');
      this.dialogRef.close();
    },err=>{
      console.log("ERROR",err.error.payload)
      this.openSnackBar(err.error.payload,'x')
    })
  }
}
